'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _eventemitter = require('eventemitter3');

var _eventemitter2 = _interopRequireDefault(_eventemitter);

var _supportPassiveEvent = require('./lib/supportPassiveEvent');

var _supportPassiveEvent2 = _interopRequireDefault(_supportPassiveEvent);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */

exports.default = {
  connections: {},
  EE: new _eventemitter2.default(),
  enableResizeInfo: false,
  enableScrollInfo: false,
  listeners: {},
  removers: [],
  supportPassiveEvent: _supportPassiveEvent2.default
};
module.exports = exports['default'];



//////////////////
// WEBPACK FOOTER
// ./~/subscribe-ui-event/dist/globalVars.js
// module id = 137
// module chunks = 0